import classes from "./Card.module.css";

const Card = (props) => {
  // const [verifyLicense, setVerifyLicense] = useState(false);
  // const [licenseKey, setlicenseKey] = useState(false);
  // const [verifyButton, setVerifyButton] = useState(true);
  // const [resultValid, setResultValid] = useState(false);
  // const [resultMessage, setResultMessage] = useState("");
  const template = props.template;

  const storeItemUrl =
    window.wpmNotificationTemplates.storeUrl + "/?p=" + template.downloadId;

  // const licenseVerficationUrl = window.wpmNotificationTemplates.storeUrl+'/wp-json/wpm-notifications/v1/template?id='+template.id+'&&key='+licenseKey;

  let isTemplateSaved =
    window.wpmNotificationTemplates.templateIds.indexOf(template.id) === -1
      ? false
      : true;

  let activeTemplateId = props.activeTemplateId;

  const cardClickHandler = (templateId) => {
    if (isTemplateSaved) {
      props.closePanel();
      props.updateTemplate({ type: "TEMPLATEUPDATE", data: templateId });
    }
  };
  // const verifyLicenseHandler = () => {
  //   setVerifyLicense(true);
  // };

  // const licenseKeyHandler = (e) => {
  //   setlicenseKey(e.target.value);
  // };

  // const licenseVerficationHandler = () => {
  //   setVerifyButton(false);
  //   setResultValid(false);

  //   fetch(window.ajaxurl, {
  //     method: "POST",
  //     body: new URLSearchParams({
  //       action: "wpm_notifications_template_license_verification",
  //       templateId: template.id,
  //       key: licenseKey,
  //       nonce: window.wpm_notifications_ajax.nonce,
  //     }),
  //   })
  //     .then((response) => response.json())
  //     .then((result) => {
  //       setVerifyButton(true);
  //       setResultMessage(result.message);
  //       setResultValid(result.valid);
  //       if (result.valid === "true") {
  //         window.wpmNotificationTemplates.templateIds.push(template.id);
  //       }
  //     });
  // };
  // const cancelButtonHandler = () => {
  //   setVerifyLicense(false);
  //   setVerifyButton(true);
  //   setResultValid(false);
  // };

  // const overlayDiv = () => {
  //   let validationMessageClass = "";
  //   switch (resultValid) {
  //     case false:
  //       validationMessageClass = classes.hidden;
  //       break;
  //     case "false":
  //       validationMessageClass = classes.errorDiv;
  //       break;
  //     default:
  //   }

  //   return (
  //     <div className={classes.mainDiv}>
  //       <input
  //         type="text"
  //         onChange={licenseKeyHandler}
  //         placeholder="Enter your License Key"
  //       />

  //       <div className={validationMessageClass}>{resultMessage}</div>
  //       {verifyButton && (
  //         <button onClick={licenseVerficationHandler}>Verify</button>
  //       )}
  //       {!verifyButton && (
  //         <span className={classes.verifyingBtn}>
  //           <span className={classes.buttonText}>Verifying</span>
  //           <span className={classes.spin}></span>
  //         </span>
  //       )}
  //       <button onClick={cancelButtonHandler}>Cancel</button>
  //     </div>
  //   );
  // };
  const templateImage = props.template.image;

  return (
    <div
      className={`${classes.box} ${
        activeTemplateId === template.id ? classes.activeTemplate : ""
      }`}
      onClick={() => cardClickHandler(template.id)}
    >
      <img src={templateImage} alt="hlo i am template" width="100%" />
      <div className={classes.overlay}>
        {!isTemplateSaved && (
          <div className={classes.mainDiv}>
            <a
              className={classes.previewBtn}
              href={storeItemUrl}
              target="_blank"
              rel="noreferrer"
            >
              Buy Now
            </a>
            {/* <button onClick={verifyLicenseHandler}>Verify</button> */}
          </div>
        )}
        {/* {!isTemplateSaved && verifyLicense && overlayDiv()} */}
      </div>
    </div>
  );
};

export default Card;
